export default "__VITE_ASSET__0828e3e9__"